import JobsLayout from "../components/tasks/JobsLayout.vue";
import Overview from "../components/tasks/Overview.vue";
const List = () => import("../components/tasks/List.vue");
const TimeCards = () => import("../components/tasks/TimeCards.vue");
const Leaderboard = () => import("../components/tasks/Leaderboard.vue");
// @ts-ignore
import store from "../store";
const resetStore = (to, from, next) => {
    store.dispatch('dataView/hardReset');
    next();
};
const routes = {
    path: '/jobs', component: JobsLayout,
    children: [
        {
            name: 'jobs.overview',
            path: 'overview',
            component: Overview,
            children: [
                {
                    name: 'jobs.new',
                    path: 'new',
                    component: Overview
                },
            ]
        },
        {
            name: 'jobs.list',
            path: 'list',
            component: List,
            beforeEnter: resetStore
        },
        {
            name: 'jobs.timecards',
            path: 'timecards',
            component: TimeCards,
            beforeEnter: resetStore
        },
        {
            name: 'jobs.leaderboard',
            path: 'leaderboard',
            component: Leaderboard,
            beforeEnter: resetStore
        },
    ]
};
export default routes;
